import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aca0398"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = ["data-kt-indicator", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Sign In", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Signing in... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "initial-values": _ctx.formData,
    "validation-schema": _ctx.formSchema,
    ref: "loginForm"
  }, {
    default: _withCtx(({ handleSubmit, values, validate }) => [
      _createElementVNode("form", {
        class: "form w-100",
        novalidate: "novalidate",
        onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.submitLoginForm)), ["prevent"])
      }, [
        _createVNode(_component_FormField, {
          required: true,
          value: values.email,
          containerClass: "fv-row",
          formControlClass: "form-control form-control-lg text-login",
          label: "Email",
          showLabel: false,
          name: "email",
          placeholder: "Email",
          type: "email"
        }, null, 8, ["value"]),
        _createVNode(_component_FormField, {
          required: true,
          value: values.password,
          containerClass: "fv-row",
          formControlClass: "form-control form-control-lg text-login",
          label: "Password",
          showLabel: false,
          name: "password",
          placeholder: "Password",
          type: "password"
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            id: "kt_sign_in_submit",
            class: "btn btn-lg w-100 mb-5 btn-sign-in",
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            onClick: validate
          }, _hoisted_6, 8, _hoisted_3)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["initial-values", "validation-schema"]))
}